import { useVoice } from "../context/voice/VoiceContext"
import Button from "../formfields/Button"


type Props = {

}

function VoiceModeToggle({ }: Props) {


    const {
        isListening,
        isRecognizerRunning,
        speechRecognitionSupported,
        startListening,
        stopListening
    } = useVoice()


    if (!speechRecognitionSupported()) {
        return null
    }


    return <Button
        onClick={() => {
            if (isRecognizerRunning) {
                stopListening()
                localStorage.setItem('savedVoiceOption', 'no')
            } else {
                startListening()
                localStorage.setItem('savedVoiceOption', 'yes')
            }
        }}
        text={isRecognizerRunning ? 'Disable voice mode' : 'Enable voice mode'}
        variant={isRecognizerRunning ? `white` : `primary`}
        align={'left'}
        size={'big'}
    />

}

export default VoiceModeToggle